import api from '../config/api';

const homeSectionService = {
  async getSectionProducts(sectionKey) {
    const response = await api.get(`/api/home-sections/${encodeURIComponent(sectionKey)}`);
    return response.data;
  },

  async updateSectionProducts(sectionKey, items) {
    const response = await api.put(`/api/home-sections/${encodeURIComponent(sectionKey)}`, {
      items: items.map((item, index) => ({
        productId: item.productId || item.id,
        displayOrder: index + 1,
      })),
    });
    return response.data;
  },
};

export default homeSectionService;
